const stripTags = (string: string): string => {
  const doc = new DOMParser().parseFromString(string, 'text/html')
  return doc.body.textContent || ''
}

export default stripTags
